import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction, Range} from 'notebook/tables/excess/FunctionConstants';
import {DivZeroError} from 'notebook/tables/excess/Util';
import toCartesianPoints from 'notebook/tables/excess/util/toCartesianPoints';
import {EvaluablePrimitive} from 'notebook/tables/typed-values/DataTypes';
import {
  fitIntercept,
  fitSlope,
  validateData,
} from 'ui-library/charting/statistics/regression/LinearRegression';
import {mean} from 'ui-library/charting/statistics/StatUtils';
import {NumericCartesianPoint} from 'ui-library/charting/Types';

export default {
  name: 'INTERCEPT',
  category: FunctionCategory.STATS,
  shortDescription: 'Calculates y-intercept of the linear regression line for a set of points.',
  description:
    'Calculates the y-intercept of the linear regression line for a set of points, ignoring any points that include non-numerical values.',
  params: [
    {
      name: "known_y's",
      type: ArgType.cellRange,
      description: 'An array or cell range of numeric dependent data points.',
    },
    {
      name: "known_x's",
      type: ArgType.cellRange,
      description: 'An array or cell range of numeric independent data points.',
    },
  ],
  eval: (knownYs: Range<EvaluablePrimitive>, knownXs: Range<EvaluablePrimitive>): number => {
    const cartesianPoints = toCartesianPoints(knownYs, knownXs);
    return calculateLinearRegressionIntercept(cartesianPoints);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;

function calculateLinearRegressionIntercept(points: Array<NumericCartesianPoint>): number {
  const dataError = validateData(points);
  if (dataError) {
    throw new DivZeroError(dataError);
  }
  const meanXs = mean(points.map((point) => point.x));
  const meanYs = mean(points.map((point) => point.y));
  const slope = fitSlope(points, meanXs, meanYs);
  return fitIntercept(meanXs, meanYs, slope);
}
